import script from "./isolated-sidepane-communication.vue?vue&type=script&setup=true&lang=ts"
export * from "./isolated-sidepane-communication.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__